"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phoneSelector = phoneSelector;
function phoneSelector(state) {
  return state.social.phone || '';
}